import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import ConditionalRender from '@/Atoms/ConditionalRender';
import CCColors from '@/Utils/CCColors';
import React, {useRef, useState} from 'react';
import {Image, Animated, StyleSheet} from 'react-native';
// import Animated from 'react-native-reanimated'
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
function BannerComponent() {
  return (
    <Box flex={1} flexDirection={'row'} style={styles.wrapper}>
      <Box flex={1} gap={20} style={[styles.text]}>
        <CCText fontSize={70} fontWeight="thunder">
          Get the&nbsp;
          <CCText fontSize={70} fontWeight="thunder" color={CCColors.Red}>
            Best Experience
          </CCText>
          &nbsp;on Our App
        </CCText>
        <CCText
          fontSize={20}
          style={{fontWeight: '500', lineHeight: 28}}
          textAlign="left">
          Enjoy a faster, smoother play experience and stay updated with the
          latest tournaments, coaching offers, and more — all in one place.
        </CCText>

        <Box
          flexDirection="row"
          justifyContent="space-between"
          gap={10}
          style={styles.flex}>
          <Image
            source={require('@/Assets/Images/Svgs/iosqr.jpg')}
            style={styles.image}
          />
          <Image
            source={require('@/Assets/Images/Svgs/androidqr.jpg')}
            style={styles.image}
          />
        </Box>
      </Box>
      <Box
        flex={1}
        justifyContent="flex-end"
        alignItems="flex-end"
        style={styles.container}>
        <Image
          source={require('@/Assets/Images/Svgs/mainappbanner.jpg')}
          style={styles.banner}
        />
      </Box>
    </Box>
  );
}
const styles = StyleSheet.create({
  image: {
    width: 240,
    height: 240,
  },
  banner: {
    position: 'absolute',
    right: '8%',
    bottom: 0,
    width: '115%',
    height: '100%',
  },
  container: {
    overflow: 'visible',
    marginLeft: 20,
    zIndex: -1,
    flex: 1,
  },
  text: {paddingTop: '5%', bottom: 60},
  wrapper: {
    marginTop: 40,
    paddingLeft: '5%',
  },
  flex: {
    flex: 1,
  },
});
export default BannerComponent;
